import { render, staticRenderFns } from "./FacturePreforma.vue?vue&type=template&id=7b5eb312&scoped=true&"
import script from "./FacturePreforma.js?vue&type=script&lang=js&"
export * from "./FacturePreforma.js?vue&type=script&lang=js&"
import style0 from "./FacturePreforma.vue?vue&type=style&index=0&id=7b5eb312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5eb312",
  null
  
)

export default component.exports